import React from 'react';
import styles from './styles/styles.module.scss';

export function ViewWrapper(props: {children: React.JSX.Element | React.JSX.Element[]}) {
	return <div className={styles.viewWrapper}>{props.children}</div>;
}
